import React, { useState, useEffect } from "react"
import Page from "@smpu-web/globalmodules/page"
import InfoBox from "./infobox"
import "../assets/style.scss"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"


const Campaign = () => {
  const sessionData = useAppSelector((state) => state.sessionData.response)

  const [campaingsText, setCampaingsText] = useState<any[]>([]);
  useEffect(() => {
    if (sessionData?.configList && !isNullOrEmpty(getConfigValue(sessionData?.configList, "UniversiteliAkbankli.Landing.Campaings"))) {
      setCampaingsText(JSON.parse(getConfigValue(sessionData?.configList, "UniversiteliAkbankli.Landing.Campaings")))
    }
  }, [sessionData])

  const infobox = () => {
    return campaingsText.map((item: any, index) => {
      return (
        <InfoBox key={item.id} id={"infobox" + item.id} img={item.image} text1={item.name} />
      );
    });
  }

  return (
    <Page padding={false}>
      {campaingsText && infobox()}
    </Page>
  )
}

export default Campaign
